import create from 'zustand';

import { logger } from 'utils/logger';

export type CLIENT_SIDE_PATH =
  | 'experience-preload'
  | 'age-brackets'
  | 'building_1'
  | 'building_2'
  | 'building_3'
  | 'contractors'
  | 'about-the-project'
  | 'landmark'
  | 'outro'
  | 'peril_1'
  | 'peril_2'
  | 'reels'
  | 'tiles'
  | 'timeline-screen'
  | 'weather'
  | 'report'
  | 'report/storm'
  | 'report/bushfire'
  | 'report/cyclone'
  | 'report/flood';

interface ClientSideRouting {
  path: CLIENT_SIDE_PATH;
  setPath: (path: CLIENT_SIDE_PATH) => void;
}

const useClientSideRouting = create<ClientSideRouting>(set => ({
  path: 'experience-preload',
  setPath: path => {
    logger.log(path);
    set({ path });
  },
}));

export default useClientSideRouting;
